import { FC, useMemo } from 'react';
import BaseComment from './BaseComment';
import { TComment } from '../types';
import { TDocument } from '@modules/documents';
import { TFile } from '@modules/files';
import { TPermissions } from '@modules/access';
import { useUsers } from '@modules/users';
import { renderMentions } from '../helpers/renderMentions.helper';
import { makeStyles, tokens } from '@fluentui/react-components';
import { TInlineBlock } from '@modules/inlineBlocks';

type NormalCommentProps = {
  comment: TComment;
  item: TDocument | TFile | TInlineBlock;
  permissions: TPermissions;
};

const useStyles = makeStyles({
  userName: {
    color: tokens.colorBrandForeground1,
  },
});

const NormalComment: FC<NormalCommentProps> = (props) => {
  const { userMap } = useUsers();
  const classes = useStyles();

  // Get the most recent content
  const initialContent = props.comment.contentVersions[props.comment.contentVersions.length - 1];

  const displayedContent = useMemo(
    () => renderMentions(initialContent, userMap, classes.userName),
    [initialContent, userMap]
  );

  return <BaseComment {...props} displayedContent={displayedContent} initialContent={initialContent} />;
};

export default NormalComment;
